
import { createContext } from "react";
import { ViewOrderContextType } from "../../types/context/ViewOrderContextType";

export const ViewOrderContext = createContext<ViewOrderContextType | null>(null);